import { draftColors } from "modules/proposals/draft/draftDesignTokens";

export const compactSelectSx = {
  height: "24px",
  fontSize: "11px",
  borderRadius: "6px",
  backgroundColor: draftColors.surface,
  "& .MuiSelect-select": { py: "2px", px: "6px", fontSize: "11px" },
};

export const worksheetHeaderGridTemplate =
  "minmax(140px, 2fr) 70px 90px 95px 95px 80px 90px 100px 55px";

export const worksheetRowGridTemplate = "20px minmax(200px, 2.5fr) 80px 84px 84px 80px 140px";

export const worksheetTableGridTemplate =
  "32px minmax(150px, 2fr) 56px 60px 78px 72px 68px 72px 72px 66px 74px 84px 56px 56px";

export const worksheetCatalogGridTemplate = "minmax(180px, 2fr) 100px 100px 120px 120px 100px";
